import React from "react";

import classes from "./Header.module.css";
import LogoIcon from "../Icon/Logo";

const Header = (props) => {
    return (
        <div className={classes.header}>
            <h1>
                <span className={classes.logo}><LogoIcon size={15} /></span>
                <span className={classes.title}>ReadyPy</span>
            </h1>
            <div className={classes.actions}>
                <nav className={classes.actionCont}>
                    <div className={classes.actionItem}>
                        <button onClick={props.handleLayoutChange}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M0,2.3C0,1,0.9,0,2,0h12c1.1,0,2,1,2,2.3v11.4c0,1.3-0.9,2.3-2,2.3H2c-1.1,0-2-1-2-2.3V2.3z M8.5,1.1v13.7H14 c0.6,0,1-0.5,1-1.1V2.3c0-0.6-0.4-1.1-1-1.1H8.5z M7.5,1.1H2c-0.6,0-1,0.5-1,1.1v11.4c0,0.6,0.4,1.1,1,1.1h5.5V1.1z"/>
                            </svg>
                            Layout
                        </button>
                    </div>
                    <div className={classes.actionItem}>
                        <button onClick={props.handleThemeChange}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                            </svg>
                            Theme
                        </button>
                    </div>
                    <div className={classes.actionItem}>
                        <button onClick={props.runCode}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13,8L2.7,2v12L13,8z M14.4,6.8c0.7,0.4,0.9,1.3,0.5,1.9c-0.1,0.2-0.3,0.4-0.5,0.5L3.1,15.8c-0.9,0.5-2.2-0.1-2.2-1.2V1.4 c0-1.2,1.3-1.8,2.2-1.2L14.4,6.8z"/>
                            </svg>
                            Run
                        </button>
                    </div>
                </nav>
            </div>
            <a
                className={classes.github}
                href="https://github.com/syan-dev/readypy"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ReadyPy on GitHub"
                title="ReadyPy on GitHub"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
                </svg>
            </a>
        </div>
    );
};

export default Header;